export const environment = {
  production: true,
  apiUrl: 'https://jonke-preview.itkaufmann.cloud/api/'
};